// extracted by mini-css-extract-plugin
export default {"project-view":"ProjectView_project-view__jDpjc","project-card-container":"ProjectView_project-card-container__n7P+n","nav-filter-container":"ProjectView_nav-filter-container__ELfzK"};